import React from 'react';
import { useStyleConfig, vui } from '../core';
import { Logo } from '../logo';
import { useHeaderContext } from './context';
/** Logo displayed in the left corner of the Header. */
export const HeaderLogo = vui((props, ref) => {
    const { brand, children, className, src, url, ...rest } = props;
    const { links } = useHeaderContext() ?? {};
    const styles = useStyleConfig('Header', useHeaderContext()).logo;
    const logoUrl = url ?? links.home;
    return (React.createElement(Logo, { brand: brand, className: className, ref: ref, src: src, styles: styles, url: logoUrl, ...rest }, children));
});
export default HeaderLogo;
